var OneTapInternalEvents;
(function(OneTapInternalEvents) {
    OneTapInternalEvents["LOGIN_SUCCESS"] = 'onetap: success login';
    OneTapInternalEvents["SHOW_FULL_AUTH"] = 'onetap: show full auth';
    OneTapInternalEvents["SHOW_AGREEMENTS_DIALOG"] = 'onetap: show agreements dialog';
    OneTapInternalEvents["START_AUTHORIZE"] = 'onetap: start authorize';
    OneTapInternalEvents["NOT_AUTHORIZED"] = 'onetap: not authorized';
})(OneTapInternalEvents || (OneTapInternalEvents = {}));

export { OneTapInternalEvents };
